module.exports = __webpack_public_path__ + "static/media/envelope.f134755a.svg";